export const computeMainCategoryFromHits = (hits = []) => {
    const categories = hits.reduce((accumulator, hit) => {
        const existingCat = accumulator.find(
            cat => cat.id === hit['categories.last_id'],
        );
        if (existingCat) {
            existingCat.count++;
            return accumulator;
        }
        return [
            ...accumulator,
            {
                id: hit['categories.last_id'],
                count: 1,
            },
        ];
    }, []);
    const sortedCategories = categories.sort((a, b) => a.count < b.count);
    return sortedCategories[0] || {};
};
